// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__xHYvs","compact":"banner_compact__RJ6w4"};